import { render, staticRenderFns } from "./MBaccarat1Cart.vue?vue&type=template&id=2049551c&scoped=true"
import script from "./MBaccarat1Cart.vue?vue&type=script&lang=js"
export * from "./MBaccarat1Cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049551c",
  null
  
)

export default component.exports